import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./AuthContext";
import OceanBackground from "./components/OceanBackground";
import ErrorBoundary from "./components/ErrorBoundary";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Drawing from "./pages/Drawing";
import Capture from "./pages/Capture";
import Result from "./pages/Result";
import Wallet from "./pages/Wallet";
import Language from "./pages/Language";
import LanguageCapture from "./pages/LanguageCapture";
import LanguageResult from "./pages/LanguageResult";
import SpeechMentor from "./pages/SpeechMentor";
import MathPage from "./pages/MathPage";
import MathCapture from "./pages/MathCapture";
import MathResult from "./pages/MathResult";
import MentalMath from "./pages/MentalMath";
import MindMaster from "./pages/MindMaster";
import HelpAFriend from "./pages/HelpAFriend";
import Privacy from "./pages/Privacy";
import DailyReflection from "./pages/DailyReflection";
import DailyReflectionResult from "./pages/DailyReflectionResult";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  if (!localStorage.getItem("dt_token")) return <Navigate to="/login" replace />;
  if (!user) return null;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="App">
          <Toaster position="bottom-center" richColors closeButton duration={3000} />
          <BrowserRouter>
          <OceanBackground />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/" element={<PrivateRoute><Landing /></PrivateRoute>} />
            <Route path="/help-a-friend" element={<PrivateRoute><HelpAFriend /></PrivateRoute>} />
            <Route path="/mind-master" element={<PrivateRoute><MindMaster /></PrivateRoute>} />
            <Route path="/drawing" element={<PrivateRoute><Drawing /></PrivateRoute>} />
            <Route path="/drawing/capture/:type" element={<PrivateRoute><Capture /></PrivateRoute>} />
            <Route path="/drawing/result" element={<PrivateRoute><Result /></PrivateRoute>} />
            <Route path="/language" element={<PrivateRoute><Language /></PrivateRoute>} />
            <Route path="/language/capture/:type" element={<PrivateRoute><LanguageCapture /></PrivateRoute>} />
            <Route path="/language/result" element={<PrivateRoute><LanguageResult /></PrivateRoute>} />
            <Route path="/language/speech-mentor" element={<PrivateRoute><SpeechMentor /></PrivateRoute>} />
            <Route path="/math" element={<PrivateRoute><MathPage /></PrivateRoute>} />
            <Route path="/math/capture/:type" element={<PrivateRoute><MathCapture /></PrivateRoute>} />
            <Route path="/math/mental-math" element={<PrivateRoute><MentalMath /></PrivateRoute>} />
            <Route path="/math/result" element={<PrivateRoute><MathResult /></PrivateRoute>} />
            <Route path="/wallet" element={<PrivateRoute><Wallet /></PrivateRoute>} />
            <Route path="/daily-reflection" element={<PrivateRoute><DailyReflection /></PrivateRoute>} />
            <Route path="/daily-reflection/result" element={<PrivateRoute><DailyReflectionResult /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </div>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
